"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _FrostedBackdrop = _interopRequireDefault(require("../FrostedBackdrop"));
var _excluded = ["children"]; // $FlowFixMe
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    paper: {
      borderRadius: 0,
      backgroundColor: 'transparent'
    }
  };
});
var CustomFrostedBackdrop = function CustomFrostedBackdrop(props) {
  return /*#__PURE__*/_react["default"].createElement(_FrostedBackdrop["default"], (0, _extends2["default"])({}, props, {
    blur: 16,
    background: (0, _defineProperty2["default"])({}, _constants.themeMode.LIGHT, '#F0F0F080')
  }));
};
var View = function View(_ref3) {
  var children = _ref3.children,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({}, props, {
    disableBackdropClick: true,
    classes: classes,
    BackdropComponent: CustomFrostedBackdrop
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: 400,
      maxHeight: 640
    }
  }, children));
};
View.displayName = 'FrostedScreenLayout';
var _default = exports["default"] = View;
//# sourceMappingURL=FrostedScreenLayout.js.map